module.exports = __webpack_public_path__ + "img/box1.5751eba5.png";